import { AbstractContentState, useCmsContent } from '@cp-shared-19/frontend-integration';
import { UnauthorizedErrorPageContentSelector } from './UnauthorizedErrorPageContentSelector';
import { HeroTeaserDto } from 'cpes-common';
import { fetchUnauthorizedError } from './UnauthorizedErrorPageSlice';

export function useUnauthorizedErrorPage(): AbstractContentState<HeroTeaserDto> {
    return useCmsContent(fetchUnauthorizedError, UnauthorizedErrorPageContentSelector);
}
